import * as React from 'react';
const SvgBookIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={20} fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M4.346 2c-.701 0-1.348.602-1.348 1.48v9.884c.416-.175.88-.26 1.38-.231h9.186c.7 0 1.347-.602 1.347-1.48V3.48c0-.903-.67-1.48-1.26-1.48H4.345ZM.998 16.52V3.48C.998 1.602 2.438 0 4.346 0h9.304c1.845 0 3.261 1.627 3.261 3.48v8.173c0 1.878-1.44 3.48-3.348 3.48H4.346c-.023 0-.047-.001-.07-.003-.632-.044-1.278.494-1.278 1.39 0 .878.647 1.48 1.348 1.48h9.304c.702 0 1.348-.602 1.348-1.48a1 1 0 1 1 2 0c0 1.878-1.44 3.48-3.348 3.48H4.346C2.44 20 .998 18.398.998 16.52Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBookIcon;
